<template>
  <div class="good" v-if="loading && haveActicy === 1">
    <div class="good-box">
      <div :class="fixedBottom ? 'fixed-bottom left' : fixed ? 'fixed left' : 'left'">
        <!-- <img src="https://img2.233.com/wx/union/618/2021/pc/hot-nav-top.png"> -->
        <img src="https://img2.233.com/wx/union/618/2021/pc/prev_nav_bg.png">
        <div class="class">
          <div class="one" v-for="item in classList" :key="item.ClassId">
            <div class="name">{{item.ClassCName}}</div>
            <div class="two">
              <span v-for="(ii, kk) in item.Child" :key="kk" @click="scrollTo(ii.ClassEName)">{{ii.ClassCName}}</span>
              <span v-if="item.Child.length % 2 === 1"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="courseList.length > 0" ref="classDomFlag">
        <div :class="[insideTime(item.StartDate, item.CloseDate) === 2 ? 'box end' : 'box', '__' + item.ExamdaClassEname]" v-for="(item, key) in courseList" :key="key">
          <div class="end-box" v-if="insideTime(item.StartDate, item.CloseDate) === 2">
            <div class="flag">抢购结束</div>
          </div>
          <div class="has-off" v-if="item.ZheKou">
            <img src="https://img2.233.com/wx/union/618/2021/pc/five-off.png">
            <span>{{item.ZheKou}}折</span>
          </div>
          <div class="img">
            <img :src="`https://img.233.com/wx/img/union/courseimg/20200225/${item.ExamdaClassEname}/${item.BzNum}.jpg`" onerror="this.src='https://img.233.com/wx/img/union/courseimg/20200225/default.jpg'">
            <div class="is-have" v-if="item.InEcart === 1">
              <span>您已有选购课程</span>
            </div>
          </div>
          <h3>{{item.CourseName}}</h3>
          <div class="old-price">
            <span>原价</span>
            <del v-if="item.MinGoodPrice === item.MaxGoodPrice">￥{{item.MaxGoodPrice}}</del>
            <del v-else>￥{{item.MinGoodPrice}}-{{item.MaxGoodPrice}}</del>
          </div>
          <div class="price-name">双11抢购价</div>
          <div class="buy">
            <div class="buy-left">
              <div class="hot-price" v-if="item.MinActivityPrice === item.MaxActivityPrice">￥{{item.MaxActivityPrice}}</div>
              <div class="hot-price" v-else>￥{{item.MinActivityPrice}}-{{item.MaxActivityPrice}}</div>
              <div class="date" v-if="insideTime(item.StartDate, item.CloseDate) === 1">{{formatDate(item.StartDate)}}开售</div>
            </div>
            <div class="button-box">
              <div class="button" v-if="insideTime(item.StartDate, item.CloseDate) === 1">
                <span @click="$emit('openCourseDialog', item)">提前预购</span>
              </div>
              <div class="button" v-else-if="insideTime(item.StartDate, item.CloseDate) === 2">
                <span>抢购结束</span>
              </div>
              <div class="button" v-else>
                <span @click="$emit('openCourseDialog', item)">立即抢购</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetGoodCourse } from "../../../lib/request"
export default {
  name: "Welfare",
  props: {
    curTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      haveActicy: 0,
      fixed: false,
      fixedBottom: false,
      classList: [],
      courseList: []
    }
  },
  mounted() {
    this.GetGoodCourse()
    window.onscroll = () => {
      const _class_dom = this.$refs.classDomFlag
      if (_class_dom) {
        this.fixed = _class_dom.getBoundingClientRect().top < 114
        const _good_left =  document.querySelector(".good .good-box .left")
        if (_good_left) {
          this.fixedBottom = _class_dom.getBoundingClientRect().height + _class_dom.getBoundingClientRect().top < _good_left.getBoundingClientRect().height + 20
        }
      } else {
        this.fixed = false
      }
    }
  },
  methods: {
    GetGoodCourse() {
      GetGoodCourse({}, (res) => {
        this.loading = true
        const { Result, ResultDescription } = res
        if (!ResultDescription) {
          const { haveActicy = 0 , LmActicityBaoKuanParentList = [], unionCourseList = [] } = Result
          this.haveActicy = haveActicy
          this.classList = LmActicityBaoKuanParentList
          this.courseList = unionCourseList
          haveActicy === 1 && this.$emit("updateVisibilit", "good")
        }
      })
    },
    insideTime(startTime, endTime) {
      if (this.curTime < new Date(startTime).getTime()) {
        return 1
      } else if (this.curTime > new Date(endTime).getTime()) {
        return 2
      } else {
        return 3
      }
    },
    formatDate(time) {
      const _time = new Date(time)
      return (_time.getMonth() + 1) + "月" + _time.getDate() + "日"
    },
    scrollTo(name) {
      const htmlScrollTop = document.querySelector("body").scrollTop
      const scrollDom = document.querySelector(htmlScrollTop === 0 ? "html" : "body")
      const mealTop = document.querySelector(".__" + name).getBoundingClientRect().top
      scrollDom.scrollTop = scrollDom.scrollTop + mealTop
    }
  }
}
</script>

<style lang="scss" scoped>
.good{
  background: url('https://img2.233.com/wx/union/618/2021/pc/good-bg.png') no-repeat top center;
  .good-box{
    padding-top: 259px;
    margin: 0 auto;
    width: 1100px;
    position: relative;
    .left{
      position: absolute;
      top: 65px;
      left: 50px;
      width: 240px;
      // height: 614px;
      img{
        vertical-align: top;
      }
      .class{
        border: 4px transparent solid;
        // border-image: linear-gradient(to right,#FFDFCD,#FF9378) 1 10;
        border-image: linear-gradient(to right, #3D49B7, #312DA7) 1 10;
        .one{
          .name{
            height: 45px;
            line-height: 45px;
            font-size: 22px;
            font-weight: 800;
            // color: #fff;
            // background: linear-gradient(90deg, #F25150 0%, #F14640 100%);
            color: #6E4732;
            background: linear-gradient(90deg, #FAE2BE 0%, #F3C066 100%);
            text-align: center;
          }
          .two{
            span{
              // color: #333;
              color: #FFF;
              font-size: 14px;
              font-weight: 400;
              width: 50%;
              display: inline-block;
              height: 40px;
              line-height: 40px;
              text-indent: 5px;
              box-sizing: border-box;
              background: #293390;
              white-space: nowrap;
              vertical-align: top;
              cursor: pointer;
              &:nth-child(4n - 1), &:nth-child(4n - 2){
                // background: #746e6b;
                background: #081260;
              }
            }
          }
        }
      }
    }
    .fixed{
      position: fixed;
      top: 0;
      left: 50%;
      margin-left: -500px;
      z-index: 2;
    }
    .fixed-bottom{
      top: unset;
      bottom: 20px;
    }
    .right{
      padding-left: 360px;
      box-sizing: border-box;
      .box{
        width: 324px;
        border-radius: 8px;
        background: #fff;
        padding: 16px 0;
        box-sizing: border-box;
        display: inline-block;
        margin: 0 20px 20px 0;
        position: relative;
        &:nth-child(2n){
          margin-right: 0;
        }
        .img{
          padding: 0 16px;
          box-sizing: border-box;
          position: relative;
          img{
            width: 292px;
            border-radius: 8px;
            vertical-align: top;
          }
          .is-have{
            position: absolute;
            top: 0;
            left: 16px;
            width: calc(100% - 32px);
            height: 100%;
            background: rgba(0, 0, 0, .7);
            text-align: center;
            span{
              height: 50px;
              line-height: 50px;
              color: #fff;
              font-size: 24px;
              font-weight: 800;
              border: 2px solid #FFFFFF;
              border-radius: 8px;
              padding: 0 20px;
              display: inline-block;
              margin-top: 55px;
            }
          }
        }
        h3{
          padding: 0 16px;
          box-sizing: border-box;
          color: #333;
          font-size: 22px;
          line-height: 22px;
          font-weight: 400;
          margin: 10px 0 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .old-price{
          padding: 0 16px;
          box-sizing: border-box;
          span, del{
            color: #999;
            font-size: 13px;
            font-weight: 400;
            line-height: 17px;
          }
          del{
            margin-left: 2px;
          }
        }
        .price-name{
          color: #E53F50;
          font-size: 16px;
          font-weight: 800;
          line-height: 16px;
          margin: 12px 0 2px;
          padding: 0 16px;
          box-sizing: border-box;
        }
        .buy{
          padding: 0 16px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .buy-left{
            .hot-price{
              color: #E53F50;
              font-size: 26px;
              line-height: 38px;
              display: inline-block;
              font-weight: 800;
              white-space: nowrap;
            }
            .date{
              font-size: 14px;
              color: #555;
              font-weight: 400;
              line-height: 18px;
            }
          }
          .button-box{
            min-width: 128px;
            .button{
              background: linear-gradient(90deg, #FF522A 0%, #DF182B 100%);
              border-radius: 24px;
              height: 48px;
              line-height: 48px;
              text-align: center;
              span{
                cursor: pointer;
                font-size: 22px;
                color: #fff;
                font-weight: 800;
                display: inline-block;
              }
            }
          }
        }
        .has-off{
          position: absolute;
          right: 0;
          top: -1px;
          z-index: 3;
          span{
            position: absolute;
            top: 0;
            left: 0;
            width: 61px;
            height: 53px;
            line-height: 46px;
            font-size: 20px;
            color: #fff;
            text-align: center;
          }
        }
      }
      .end{
        .button-box{
          .button{
            background: #EFEFEF !important;
            span{
              color: #888 !important;
            }
          }
        }
        .end-box{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, .7);
          text-align: center;
          border-radius: 8px;
          z-index: 9;
          .flag{
            height: 50px;
            line-height: 50px;
            color: #fff;
            font-size: 24px;
            font-weight: 800;
            border: 2px solid #FFFFFF;
            border-radius: 8px;
            padding: 0 20px;
            display: inline-block;
            margin-top: 140px;
          }
        }
      }
    }
  }
}
</style>